<div class="fx_modal_container more-comcond">

<!-- [style.display]="!isCollapse?'block':'none'" -->
    <div dw-row class="ant-advanced-search-form dw-f-search-form-block" [style.display]="!isCollapse?'block':'none'">
      <div dw-col [dwSpan]="12" *ngFor="let searchObj of searchVal; index as index">
        <div dw-col [dwSpan]="24" [ngClass]="{'noneMargin': searchVal.length > 2 }">
          <dw-form-item dw-row>
            <dw-form-control style="width: 33%">
              <dw-select style="width: 100%" dwMode="default"  [(ngModel)]="searchObj.field_no" (ngModelChange)="changesearchfield(index)">
                <dw-option *ngFor="let option of searchlableList" [dwLabel]="option.label" [dwValue]="option.value"></dw-option>
              </dw-select> 
            </dw-form-control>
            <dw-form-control style="width: 26%">
              <dw-select style="width: 100%" dwMode="default"  [(ngModel)]="searchObj.condition" >
                <dw-option *ngFor="let option of searchCondList[searchObj.cond_type]" [dwLabel]="option.label" [dwValue]="option.value"></dw-option>
              </dw-select>
            </dw-form-control>
            <dw-form-control style="width: 45%" *ngIf="searchObj.aap003 != '3'">
              <dw-form-input name="searchvalue2" [(ngModel)]="searchObj.value" dwInputSpan="24" (keyup)="searchFn($event)"></dw-form-input>
            </dw-form-control>
            <dw-form-control style="width: 45%" *ngIf="searchObj.aap003 == '3'" (keyup)="searchFn($event)">
              <dw-form-select style="width: 100%" [(ngModel)]="searchObj.value" [dwOptionList]="searchObj.aap004 ? (userinfo.getSysEnumById$(searchObj.aap004)|async) : []"
                dwPlaceHolder="{{'com-请选择' | translate}}" dwNotFoundContent="{{'com-无选项' | translate}}" dwShowSearch dwAllowClear>
              </dw-form-select>
            </dw-form-control>

            <!--<dw-form-control style="width: 45%" *ngIf="searchObj.lable_type == '4'">
              <dw-form-date-picker name="searchvalue2"  [(ngModel)]="searchObj.value" dwInputSpan="24" (keyup)="searchFn($event)">
              </dw-form-date-picker>
            </dw-form-control>
            <dw-form-control style="width: 45%" *ngIf="searchObj.lable_type == '5'">
              <dw-form-date-picker name="searchvalue2"  [(ngModel)]="searchObj.value" dwShowTime dwInputSpan="24" (keyup)="searchFn($event)">
              </dw-form-date-picker>
            </dw-form-control>
            <dw-form-control style="width: 45%" *ngIf="searchObj.lable_type == '7'" (keyup)="searchFn($event)">
              <dw-month-picker  [(ngModel)]="searchObj.value">
              </dw-month-picker>
            </dw-form-control>
            <dw-form-control style="width: 45%" *ngIf="searchObj.lable_type == '8'" (keyup)="searchFn($event)">
              <dw-form-range-picker [(ngModel)]="searchObj.value"
                [dwPlaceHolder]="['开始日期','结束日期']">
              </dw-form-range-picker>
            </dw-form-control> -->
          </dw-form-item>
        </div>
      </div>
    </div>
      </div>
  